import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './router';
import Layout from './layout/Layout';
import { ToastContainer } from 'react-toastify';
import { initializeTapfiliate } from './services/tapfiliate';
import CookieConsentBanner from './components/CookieConsent';
import { CookieConsentProvider } from './providers/CookieConsentContext';
import InactivityProvider from './providers/InactivityProvider';
import { SurveyProvider } from './providers/SurveyProvider';
import SurveyPopup from './components/SurveyPopup';
import { useUserActivityPing } from './hooks/useUserActivityPing';

const App: React.FC = () => {
  // Handle logout on browser/tab close
  // useLogoutOnUnload();

  // Ping user activity every 2 minutes when authenticated
  useUserActivityPing();

  useEffect(() => {
    try {
      initializeTapfiliate();
    } catch (error) {
      console.error('Tapfiliate initialization error:', error);
    }
  }, []);

  // Disable right-click context menu globally
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  return (
    <CookieConsentProvider>
      <Router>
        <InactivityProvider>
          <SurveyProvider>
            <Layout>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
                style={{ width: 'auto', whiteSpace: 'pre-line' }}
              />
              <AppRouter />
              <CookieConsentBanner />
              <SurveyPopup />
            </Layout>
          </SurveyProvider>
        </InactivityProvider>
      </Router>
    </CookieConsentProvider>
  );
};

export default App;
